
import React, { useState, useEffect } from 'react';
import './ClientReviews.css';

const reviews = [
    "Muhammad Hadi: Excellent service! The team was professional and efficient.",
    "Haseeb Ali: Highly recommend! They exceeded my expectations in every way.",
    "Abdullah Sehryar: Great customer support! Quick responses and very helpful.",
    "Abdul-Ahmed: Reliable and professional! Delivered exactly what was promised.",
    "Sara Khan: Outstanding quality! The attention to detail was superb.",
    "Ayesha Malik: Fantastic experience! I will definitely be using their services again.",
    "Zainab Iqbal: Timely and trustworthy! They truly care about their clients."
];

const ClientReviews = () => {
    const [currentReview, setCurrentReview] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentReview((prevReview) => (prevReview + 1) % reviews.length);
        }, 2000);

        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, []);

    const handleNext = () => {
        setCurrentReview((prevReview) => (prevReview + 1) % reviews.length);
    };

    const handlePrev = () => {
        setCurrentReview((prevReview) =>
            prevReview === 0 ? reviews.length - 1 : prevReview - 1
        );
    };

    return (
        <div className="client-reviews">
            <h2>Client Reviews</h2>
            <div className="review">{reviews[currentReview]}</div>
            <div className="arrows">
                <button onClick={handlePrev} className="arrow left">&lt;</button>
                <button onClick={handleNext} className="arrow right">&gt;</button>
            </div>
        </div>
    );
};

export default ClientReviews;